import { makeSceneDoc } from '../kit.js';

/**
 * 城门口：进城第一关。
 * 守门卒看人发证，证照窗口直接连着衙门大堂；夜里城门关闭，只能在外面熬到天亮。
 */
export const gateDoc = makeSceneDoc({
  id: 'gate',
  name: '城门口',
  region: 'city',
  tier: 2,
  node: 'gate',
  desc: '城墙高得看不见顶，门洞里排着进城的队。',
  w: 44, h: 26,
  fill: '=',
  spawn: { gx: 22, gy: 21 },
  draw(b, rng) {
    b.rect(0, 0, 44, 26, '=');
    b.rect(0, 0, 44, 5, ',');                      // 城外一侧的空地
    b.rect(0, 5, 8, 6, '#');                       // 城墙（左）
    b.rect(36, 5, 8, 6, '#');                      // 城墙（右）
    b.rect(8, 8, 28, 3, '^');                      // 门洞地面（关卡石）
    b.rect(8, 5, 28, 3, '#');                      // 门楼
    // 门洞：中轴 22 那五格从城外一路穿到城内，早先这道墙没开口，
    // 人从官道进来只能站在城外空地上，进不了城。
    b.rect(20, 5, 5, 3, '^');
    b.rect(14, 11, 16, 15, '=');                   // 城内广场
    b.rect(0, 11, 14, 15, ',');
    b.rect(30, 11, 14, 15, ',');
    b.scatter('o', 20, { rng, area: [14, 12, 15, 12] });
  },
  props: [
    { type: 'license_window', gx: 30, gy: 13 },
    { type: 'checkpoint_shed', gx: 12, gy: 13 },
    { type: 'guard_post', gx: 26, gy: 13 },
    // 排队栏杆挪到门洞两侧：物件表里没有 gate_in / gate_out 这两样，
    // 原先摆在中轴上会被当成实心物，等于把门洞堵死。
    { type: 'queue_fence', gx: 18, gy: 9 },
    { type: 'queue_fence', gx: 19, gy: 9 },
    { type: 'queue_fence', gx: 26, gy: 9 },
    { type: 'notice_board', gx: 16, gy: 12 },
    { type: 'water_well', gx: 32, gy: 18 },
    // 城门楼骑在城墙上，中轴那五格留空当门洞，分作左右两座，别压在门洞上
    { type: 'place_gate', gx: 15, gy: 5, state: { name: '城门楼' } },
    { type: 'place_gate', gx: 25, gy: 5, state: { name: '城门楼' } },
  ],
  portals: [
    { to: 'highway', gx: 22, gy: 1, spawn: [22, 23], label: '出城' },
    { to: 'main_street', gx: 22, gy: 24, spawn: [22, 2], label: '进城：主街' },
    { to: 'yamen_sq', gx: 42, gy: 16, spawn: [3, 14], label: '衙前广场' },
  ],
});

export default gateDoc;
